var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-timeline',{attrs:{"dense":"","align-top":""}},_vm._l((_setup.props.items),function(item){return _c(_setup.ActivityTimelineItem,{key:item.id,attrs:{"item":item},on:{"click:document":function($event){return _vm.$emit('click:document', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }